import BaseApi from "@api/base.api";
import Http from "@services/http";

export default class BusinessDomainsApi extends BaseApi {
    static get entity() {
        return "business-domains";
    }

    static async getDomainsByOfferings(params = {}) {
            return await Http.get(`${this.entity}/get-domains-by-offerings`, params);
    }
}

